import { ASSOCIATE_USER, GET_USER_SUGGESTION } from '../../store/modules/linkUser/linkUser.actions';
import { CLEAR_USER_SUGGESTION, SELECTED_USER_ID, SELECTED_ROLE, SELECTED_USER_TYPE, DISPLAYED_MESSAGE_DATA } from '../../store/modules/linkUser/linkUser.mutations';

export default {
  associateUserWitHospital() {
    this.$store.dispatch(ASSOCIATE_USER, {
      hospitalId: this.$route.params.hospitalId,
      userId: this.$store.state.linkUser.selectedUserId,
      role: this.$store.state.linkUser.selectedRole,
      displayName: this.$store.state.linkUser.selectedDisplayName,
    });
  },
  getUserSuggestion(query) {
    if (query) {
      this.$store.dispatch(GET_USER_SUGGESTION, { query });
    } else {
      this.$store.commit(CLEAR_USER_SUGGESTION);
    }
  },
  processJSON(json) {
    return json.users;
  },
  handleSelect(user) {
    /* eslint-disable no-underscore-dangle */
    this.userId = user._id;
    const payload = {
      selectedUserId: user._id,
      selectedDisplayName: user.displayName,
    };
    this.$store.commit(SELECTED_USER_ID, payload);
  },
  onRoleSelected(event) {
    const role = event.target.value;
    this.$store.commit(SELECTED_ROLE, role);
  },
  onUserTypeSelected(event) {
    const userType = event.target.value;
    this.$store.commit(SELECTED_USER_TYPE, userType);
    this.$store.commit(DISPLAYED_MESSAGE_DATA, { isResponseMessageVisible: false });
  },

  handleAutocompleteInput() {
    this.userId = null;
  },
};



// WEBPACK FOOTER //
// ./src/components/OrganizationAdminLinkScreen/organizationAdminLinkScreen.methods.js